import useLocalStorage from './useLocalStorage'

const LOCAL_STORAGE_KEY = 'prefers_color_scheme'
const INITIAL_VALUE = 'system'

export default function useColorScheme() {
  const [colorScheme, setColorScheme] = useLocalStorage(LOCAL_STORAGE_KEY,INITIAL_VALUE)
  return { colorScheme, setColorScheme }
}